let items = document.querySelectorAll('.carousel-desktop .carousel-item')

items.forEach((el, key) => {
    const minPerSlide = 3
    let next = el.nextElementSibling
    for (var i=1; i<minPerSlide; i++) {
        if (!next) {
            // wrap carousel by using first child
        	next = items[0]
      	}
        let cloneChild = next.cloneNode(true)
        cloneChild.children[0].children[0].setAttribute('data-lightbox', 'our-store-desktop-'+key)
        el.appendChild(cloneChild.children[0])
        next = next.nextElementSibling
    }
})